import React, {
  Fragment, useEffect, useState,
} from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './styles.scss';
import {
  ShoppingFilled,
} from '@ant-design/icons';
import {
  Table, Drawer, Button, notification,
  Popconfirm,
  Popover,
} from 'antd';
import H3Text from '@Uilib/h3Text';
import {
  QUANTITY, toISTDate,
} from '@Apis/constants';
import Helpers from '@Apis/helpers';
import H3FormInput from '@Uilib/h3FormInput';
import OfferActions from '@Actions/offerActions';
import CartActions from '@Actions/cartActions';
import H3Image from '@Uilib/h3Image';
import imageDefault from '@Images/icons/imageDefault.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashCan } from '@fortawesome/free-solid-svg-icons';
import AddToCartActions from '../../../actions/addToCart/addToCartActions';
import ConvertCartToMo from './ConvertCartToMo';
import closeIcon from '@Images/icons/icon-close-blue.png';

const PreviewCart = ({
  user, history, getCartV2, getCartV2Loading, removeFromCartV2, getTenantSkuOffer, getOfferByTenantSkuLoading,
}) => {
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [cart, setCart] = useState({});
  const [call, setCall] = useState(false);
  const [showConvertToMo, setShowConvertToMo] = useState(false);
  const [skuQtyMap, setSkuQtyMap] = useState({});

  useEffect(() => {
    if (user) {
      getCartV2({ tenantId: user?.tenant_info?.tenant_id }, (cartData) => setCart(cartData));
    }
  }, [call]);

  const updateCartValue = (value, record, label) => {
    // Create a deep copy of the cart
    const copyCart = JSON.parse(JSON.stringify(cart));

    // Map through the products and update the specific product
    const updatedProducts = copyCart.result.products.map((item) => {
      if (item.tenant_product_id === record.tenant_product_id) {
        item[label] = value;
      }
      return item;
    });
    // Update the cart with the new products
    const newCart = {
      ...copyCart,
      result: {
        ...copyCart.result,
        products: updatedProducts,
      },
    };
    setCart(newCart);
  };

  function mergeSellerOffers(dataForPrefillPR, sellerOffers) {
    // Create a map for quick lookup of dataForPrefillPR by tenant_product_id
    const dataForPrefillPRMap = new Map();
    dataForPrefillPR?.forEach((item) => {
      dataForPrefillPRMap.set(item.tenant_product_id, item);
    });

    // Iterate through sellerOffers and add them to the corresponding dataForPrefillPR item
    sellerOffers?.forEach((offer) => {
      const matchingItem = dataForPrefillPRMap.get(offer.tenant_product_id);
      if (matchingItem) {
        if (!matchingItem.sellerOffers) {
          matchingItem.sellerOffers = [];
        }
        matchingItem.sellerOffers.push(offer);
      }
    });

    return dataForPrefillPR;
  }

  const cartColumns = [
    {
      title: 'Product Name',
      render: (record) => (
        <div>
          <Link to={`/inventory/product/view/${record?.product_info?.product_sku_id}`} target="_blank">
            <span style={{ color: 'rgb(45, 125, 247)' }}>{record?.product_info?.internal_sku_code}</span>
          </Link>
          {' '}
          -
          {' '}
          {record?.product_info?.product_sku_name}
        </div>
      ),
    },
    {
      title: 'STOCK IN DEFAULT DEPT',
      render: (record) => {
        const uomInfo = record?.uom_info;
        const uomList = record?.uom_list;
        const value = record?.store_stock || 0;
        const quantityInDiffUoms = (
          <div>
            {
              uomList?.map((uom, i) => (
                <div className="other-uom-stock" key={i}>
                  <div>
                    {QUANTITY((value * uomInfo?.ratio) / uom?.ratio, uom?.precision)}
                  </div>
                  <div>
                    {uom?.uqc?.toProperCase()}
                  </div>
                </div>
              ))
            }
          </div>
        );
        return (
          <Fragment>
            {
              ['STORABLE', 'BUNDLE'].includes(record?.product_type?.toUpperCase()) ? (
                <React.Fragment>
                  <Popover placement="bottom" content={quantityInDiffUoms} title="Quantity in other units" trigger="hover">
                    <div style={{ cursor: 'pointer' }}>{`${QUANTITY(record?.store_stock || '0', record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()}`}</div>
                  </Popover>
                  {(record?.total_available_qty - record?.store_stock) > 0 && (
                    <H3Text
                      text={`${QUANTITY((record?.total_available_qty - record?.store_stock) || '0', record?.uom_info?.precision)} ${record?.uom_info?.uqc?.toProperCase()} in other departments`}
                      className="table-subscript other-dept-stock-subscript"
                    />
                  )}
                </React.Fragment>
              ) : '-'
            }
          </Fragment>
        );
      },
    },
    {
      title: 'Quantity',
      render: (text, record) => (
        <H3FormInput
          value={record.quantity}
          type="number"
          containerClassName={`orgInputContainer ${(formSubmitted && !Number(record.quantity)) ? 'cart-review__input-error' : ''}`}
          labelClassName="orgFormLabel"
          inputClassName="orgFormInput"
          onChange={(e) => updateCartValue(e.target.value, record, 'quantity')}
          required
        />
      ),
    },
    {
      title: 'Unit',
      width: '120px',
      render: (text, record) => (
        <div>
          {record?.uom_info?.uqc?.toProperCase()}
        </div>
      ),
    },
    {
      title: '',
      fixed: 'right',
      render: (text, record) => (
        <Popconfirm
          placement='topRight'
          title="Are you sure you want to remove this item from cart?"
          onConfirm={() => {
            removeFromCartV2({ product_sku_ids: [record?.product_sku_id], tenant_id: user?.tenant_info?.tenant_id }, () => setCall(!call));
          }}
        >
          <div className="delete-line-button__new" style={{ marginLeft: 'auto' }}>
            <FontAwesomeIcon icon={faTrashCan} />
          </div>
        </Popconfirm>
      ),
    },
  ];

  return (
    <div className="cart__preview-container">
      <Table
        title={() => (
          <div className="cart__preview-title">
            <div className="cart__preview-title-icon">
              <ShoppingFilled />
            </div>
            {Number(cart?.count) || 0}
            {' '}
            Items added to cart
          </div>
        )}
        pagination={false}
        loading={getCartV2Loading}
        columns={cartColumns}
        size="small"
        dataSource={cart?.result?.products}
      />
      {Number(cart?.count) > 0 && <div className="cart__preview__footer-container">
        <div className="cart__preview__footer-right">
          <Button
            type="primary"
            ghost
            onClick={() => {
              const allProductIds = cart?.result?.products?.map((item) => item?.product_sku_id);
              removeFromCartV2({ product_sku_ids: allProductIds, tenant_id: user?.tenant_info?.tenant_id }, () => setCall(!call));
            }}
          >
            Clear Cart
          </Button>
        </div>
        {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_REQUEST,
          Helpers.permissionTypes.CREATE, user) && (
            <div className="cart__preview__footer-right">
              <Button
                type="primary"
                onClick={() => {
                  const tempDataForPrefillPR = cart?.result?.products;
                  const tenantProductIds = tempDataForPrefillPR?.map((item) => item?.tenant_product_id)?.join(',');
                  getTenantSkuOffer(tenantProductIds, '', (sellerOffer, sellerOffers) => {
                    const updatedDataForPrefillPR = mergeSellerOffers(tempDataForPrefillPR, sellerOffers);
                    history.push({
                      pathname: '/purchase/purchase-request/create',
                      state: {
                        dataForPrefillPR: updatedDataForPrefillPR,
                      },
                    });
                  });
                }}
                loading={getOfferByTenantSkuLoading}
              >
                + Material Request
              </Button>
            </div>
          )}
        {Helpers.getPermission(Helpers.permissionEntities.PURCHASE_ORDER,
          Helpers.permissionTypes.CREATE, user) && (
            <div className="cart__preview__footer-right">
              <Button
                type="primary"
                onClick={() => {
                  const tempDataForPrefillPO = cart?.result?.products;
                  const tenantProductIds = tempDataForPrefillPO?.map((item) => item?.tenant_product_id)?.join(',');
                  getTenantSkuOffer(tenantProductIds, '', (sellerOffer, sellerOffers) => {
                    const updatedDataForPrefillPO = mergeSellerOffers(tempDataForPrefillPO, sellerOffers);
                    history.push({
                      pathname: '/purchase/purchase-orders/create',
                      state: {
                        dataForPrefillPO: updatedDataForPrefillPO,
                      },
                    });
                  });
                }}
                loading={getOfferByTenantSkuLoading}
              >
                + Purchase Orders
              </Button>
            </div>
          )}

        {Helpers.getPermission(Helpers.permissionEntities.MO,
          Helpers.permissionTypes.CREATE, user) && (
            <div className="cart__preview__footer-right">
              <Button
                type="primary"
                onClick={() => {
                  const map = {};
                  cart?.result?.products?.forEach((item) => {
                    map[item.product_sku_id] = item.quantity || 0;
                  });
                  setSkuQtyMap(map);
                  setShowConvertToMo(true)
                }}
                loading={getOfferByTenantSkuLoading}
              >
                + Manufacturing Orders
              </Button>
            </div>
          )}
      </div>}

      <Drawer
          onClose={() => setShowConvertToMo(false)}
          open={showConvertToMo}
          width="970px"
          destroyOnClose
        >
          <div className="custom-drawer__header-wrapper">
            <div className="custom-drawer__header" style={{ width: '920px' }}>
              <H3Text text="Create Manufacturing Orders" className="custom-drawer__title" />
              <H3Image src={closeIcon} className="custom-drawer__close-icon" onClick={() => setShowConvertToMo(false)} />
            </div>
          </div>
          <ConvertCartToMo
            skuQtyMap={skuQtyMap}
            selectedRows={cart?.result?.products?.map((item) => item?.product_sku_id)}
            callback={() => {
              setShowConvertToMo(false);
              setCall(!call);
            }}
          />
        </Drawer>
    </div>
  );
};
const mapStateToProps = ({ UserReducers, AddToCartReducers, OfferReducers }) => ({
  user: UserReducers.user,
  addToCartLoading: AddToCartReducers.addToCartLoading,
  MONEY: UserReducers.MONEY,
  getCartV2Loading: AddToCartReducers.getCartV2Loading,
  getOfferByTenantSkuLoading: OfferReducers.getOfferByTenantSkuLoading,
});

const mapDispatchToProps = (dispatch) => ({
  getOffers: (tenantProductId, tenantSellerId) => dispatch(OfferActions.getOffers(tenantProductId, tenantSellerId)),
  getCartV2: (payload, callback) => dispatch(AddToCartActions.getCartV2(payload, callback)),
  addToCart: (payload, tenantId, callback) => dispatch(CartActions.addToCart(payload, tenantId, callback)),
  removeFromCartV2: (payload, callback) => dispatch(AddToCartActions.removeFromCartV2(payload, callback)),
  getTenantSkuOffer: (tenantProductId, tenantSellerId, callback) => dispatch(OfferActions.getOfferByTenantSku(tenantProductId, tenantSellerId, callback)),
});

PreviewCart.propTypes = {
  getCartV2: PropTypes.func,
  user: PropTypes.any,
  history: PropTypes.func,
  MONEY: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PreviewCart));
